import { RStoreSchema } from '#imports';
import { OrgRole } from '~/rstore/schema/system/org-role';
import { User } from '~/rstore/schema/system/user';
import { UserOrgRole } from '~/rstore/schema/system/user-org-role';
import { Workspace } from '~/rstore/schema/system/workspace';
import { RawPolicy, RolePolicy } from './policies';
import { Role, RoleClosure, UserRole } from './roles';
import { WorkspaceMember } from './workspace-member';

// Role relations
export const RoleRelations = RStoreSchema.defineRelations(Role, ({ collection }) => ({
	parent: {
		to: collection(Role, {
			on: {
				'MonospaceRole.id': 'MonospaceRole.parentId',
			},
		}),
	},
	users: {
		to: collection(UserRole, {
			on: {
				'MonospaceUserRole.roleId': 'MonospaceRole.id',
			},
		}),
		many: true,
	},
	policies: {
		to: collection(RolePolicy, {
			on: {
				'MonospaceRolePolicy.roleId': 'MonospaceRole.id',
			},
		}),
		many: true,
	},
	ancestors: {
		to: collection(RoleClosure, {
			on: {
				'MonospaceRoleClosure.descendantId': 'MonospaceRole.id',
			},
		}),
		many: true,
	},
	descendants: {
		to: collection(RoleClosure, {
			on: {
				'MonospaceRoleClosure.ancestorId': 'MonospaceRole.id',
			},
		}),
		many: true,
	},
}));

export const OrgRoleRelations = RStoreSchema.defineRelations(OrgRole, ({ collection }) => ({
	users: {
		to: collection(UserOrgRole, {
			on: {
				'MonospaceUserOrgRole.orgRoleId': 'MonospaceOrgRole.id',
			},
		}),
		many: true,
	},
}));

export const UserRoleRelations = RStoreSchema.defineRelations(UserRole, ({ collection }) => ({
	user: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceUserRole.userId',
			},
		}),
	},
	role: {
		to: collection(Role, {
			on: {
				'MonospaceRole.id': 'MonospaceUserRole.roleId',
			},
		}),
	},
}));

export const UserOrgRoleRelations = RStoreSchema.defineRelations(UserOrgRole, ({ collection }) => ({
	user: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceUserOrgRole.userId',
			},
		}),
	},
	role: {
		to: collection(OrgRole, {
			on: {
				'MonospaceOrgRole.id': 'MonospaceUserOrgRole.orgRoleId',
			},
		}),
	},
}));

// Policy relations
export const RolePolicyRelations = RStoreSchema.defineRelations(RolePolicy, ({ collection }) => ({
	policy: {
		to: collection(RawPolicy, {
			on: {
				'RawMonospacePolicy.id': 'MonospaceRolePolicy.policyId',
			},
		}),
	},
	role: {
		to: collection(Role, {
			on: {
				'MonospaceRole.id': 'MonospaceRolePolicy.roleId',
			},
		}),
	},
}));

export const RawPolicyRelations = RStoreSchema.defineRelations(RawPolicy, ({ collection }) => ({
	roles: {
		to: collection(RolePolicy, {
			on: {
				'MonospaceRolePolicy.policyId': 'RawMonospacePolicy.id',
			},
		}),
		many: true,
	},
}));

// WorkspaceMember relations
export const WorkspaceMemberRelations = RStoreSchema.defineRelations(WorkspaceMember, ({ collection }) => ({
	roles: {
		to: collection(UserRole, {
			on: {
				'MonospaceUserRole.userId': 'MonospaceSystemUser.id',
			},
		}),
		many: true,
	},
}));

// Cross-domain relations: connect system collections to workspace-scoped collections
export const WorkspaceRelations = RStoreSchema.defineRelations(Workspace, ({ collection }) => ({
	members: {
		to: collection(WorkspaceMember, {
			on: {
				'MonospaceSystemUser.workspaceId': 'MonospaceWorkspace.id',
			},
		}),
		many: true,
	},
}));

export const RoleClosureRelations = RStoreSchema.defineRelations(RoleClosure, ({ collection }) => ({
	ancestor: {
		to: collection(Role, {
			on: {
				'MonospaceRole.id': 'MonospaceRoleClosure.ancestorId',
			},
		}),
	},
	descendant: {
		to: collection(Role, {
			on: {
				'MonospaceRole.id': 'MonospaceRoleClosure.descendantId',
			},
		}),
	},
}));
